/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function GuardianField (props: FormTextFieldProps) {
  const { name = 'guardian', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'guardian',
        defaultMessage: 'Gardien'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default GuardianField
